import { createRouter, createWebHistory } from 'vue-router';
import { APP_ROUTES } from '@/constants';
var routes = [
    {
        path: APP_ROUTES.ROOT.PATH,
        name: APP_ROUTES.ROOT.NAME,
        component: function () { return import(
        /* webpackChunkName: "page-stocks" */
        '@/views/page-stocks.vue'); },
    },
    {
        path: APP_ROUTES.STOCK.PATH,
        name: APP_ROUTES.STOCK.NAME,
        component: function () { return import(
        /* webpackChunkName: "page-stock" */
        '@/views/page-stock.vue'); },
        props: true,
    },
];
var router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routes,
});
export default router;
